import styled from 'styled-components'

export default styled.a`
  color: inherit;
  text-decoration: underline;
}`